import React from 'react';
import { ArrowRight } from 'lucide-react';
const PaletteIcon = () => <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-24 h-24" data-id="element-211">
    <g filter="url(#shadow)" data-id="element-212">
      {/* Base palette */}
      <rect x="40" y="80" width="120" height="80" rx="4" fill="#2ecc71" opacity="0.9" data-id="element-213" />
      <rect x="40" y="80" width="120" height="80" rx="4" fill="url(#gradient)" opacity="0.3" data-id="element-214" />

      {/* Planches horizontales */}
      <rect x="40" y="85" width="120" height="8" fill="#27ae60" data-id="element-215" />
      <rect x="40" y="110" width="120" height="8" fill="#27ae60" data-id="element-216" />
      <rect x="40" y="135" width="120" height="8" fill="#27ae60" data-id="element-217" />

      {/* Dés verticaux */}
      <rect x="50" y="80" width="12" height="80" fill="#229954" opacity="0.8" data-id="element-218" />
      <rect x="94" y="80" width="12" height="80" fill="#229954" opacity="0.8" data-id="element-219" />
      <rect x="138" y="80" width="12" height="80" fill="#229954" opacity="0.8" data-id="element-220" />

      {/* Effet 3D */}
      <path d="M40 160 L160 160 L165 165 L35 165 Z" fill="#1e8449" opacity="0.6" data-id="element-221" />
      <path d="M160 80 L160 160 L165 165 L165 85 Z" fill="#1e8449" opacity="0.4" data-id="element-222" />
    </g>

    <defs data-id="element-223">
      <linearGradient id="gradient" x1="40" y1="80" x2="160" y2="160" data-id="element-224">
        <stop offset="0%" stopColor="#ffffff" stopOpacity="0.3" data-id="element-225" />
        <stop offset="100%" stopColor="#000000" stopOpacity="0.1" data-id="element-226" />
      </linearGradient>
      <filter id="shadow" x="0" y="0" width="200" height="200" data-id="element-227">
        <feDropShadow dx="2" dy="4" stdDeviation="3" floodOpacity="0.2" data-id="element-228" />
      </filter>
    </defs>
  </svg>;
export function PaletteCategories() {
  const categories = [{
    title: 'Palettes bois neuves',
    description: "Palettes certifiées, traitées selon les normes NIMP-15 pour l'export.",
    sizes: ['40x60', '60x80', '80x120', '100x120', 'Europe', 'VMF'],
    badge: 'Certifié'
  }, {
    title: 'Palettes bois occasion',
    description: 'Palettes reconditionnées, contrôle qualité rigoureux, idéal pour circuit interne.',
    sizes: ['40x60', '60x80', '80x120', '100x120', 'Europe', 'VMF'],
    badge: 'Économique'
  }, {
    title: 'Palettes plastique neuves',
    description: "Palettes hygiéniques, lavables, idéales pour l'agroalimentaire et la pharmacie.",
    sizes: ['40x60', '60x80', '80x120', '100x120', '120x120'],
    badge: 'Premium'
  }, {
    title: 'Palettes plastique occasion',
    description: 'Palettes plastique reconditionnées, excellent rapport qualité/prix.',
    sizes: ['40x60', '60x80', '80x120', '100x120', '120x120'],
    badge: 'Durable'
  }];
  return <section id="gamme" className="py-24 bg-gradient-to-b from-white to-gray-50" data-id="element-229">
      <div className="w-full max-w-[1200px] mx-auto px-6" data-id="element-230">
        <div className="text-center mb-16" data-id="element-231">
          <span className="text-primary font-semibold tracking-wider uppercase text-sm" data-id="element-232">
            Notre catalogue
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-secondary-dark mt-3 mb-6" data-id="element-233">
            Une gamme complète pour tous vos besoins
          </h2>
          <p className="text-lg text-gray-500 max-w-2xl mx-auto" data-id="element-234">
            Des solutions adaptées à chaque secteur d'activité, disponibles en
            grandes quantités.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-235">
          {categories.map((category, index) => <div key={index} className="group bg-white rounded-2xl border border-gray-100 overflow-hidden hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 flex flex-col relative" style={{
          animationDelay: `${index * 100}ms`
        }} data-id="element-236">
              {/* Badge */}
              <div className="absolute top-4 right-4 z-10" data-id="element-237">
                <span className="px-3 py-1 bg-primary text-white text-xs font-semibold rounded-full shadow-lg" data-id="element-238">
                  {category.badge}
                </span>
              </div>

              <div className="h-[220px] bg-gradient-to-br from-primary-light/20 to-primary-light/5 flex items-center justify-center relative overflow-hidden" data-id="element-239">
                <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent" data-id="element-240"></div>
                <div className="relative z-10 transform group-hover:scale-110 transition-transform duration-500" data-id="element-241">
                  <PaletteIcon data-id="element-242" />
                </div>
                {/* Decorative circles */}
                <div className="absolute top-4 left-4 w-16 h-16 bg-primary/10 rounded-full blur-xl" data-id="element-243"></div>
                <div className="absolute bottom-4 right-4 w-20 h-20 bg-primary/10 rounded-full blur-xl" data-id="element-244"></div>
              </div>

              <div className="p-6 flex-1 flex flex-col" data-id="element-245">
                <h3 className="text-lg font-bold text-secondary-dark mb-3 group-hover:text-primary transition-colors" data-id="element-246">
                  {category.title}
                </h3>
                <p className="text-gray-500 text-sm mb-6 leading-relaxed flex-1" data-id="element-247">
                  {category.description}
                </p>

                <div className="flex flex-wrap gap-2 mb-6" data-id="element-248">
                  {category.sizes.slice(0, 3).map((size, i) => <span key={i} className="bg-gray-50 border border-gray-100 px-2 py-1 rounded text-[10px] font-medium text-gray-500 uppercase tracking-wide" data-id="element-249">
                      {size}
                    </span>)}
                  {category.sizes.length > 3 && <span className="bg-gray-50 border border-gray-100 px-2 py-1 rounded text-[10px] font-medium text-gray-500" data-id="element-250">
                      +{category.sizes.length - 3}
                    </span>}
                </div>

                <a href="#contact" className="w-full py-3 rounded-xl bg-gradient-to-r from-primary/5 to-primary/10 border border-primary/20 text-primary font-semibold text-sm flex items-center justify-center gap-2 hover:from-primary hover:to-primary-dark hover:text-white transition-all duration-300 shadow-sm hover:shadow-lg group/btn" data-id="element-251">
                  Demander un devis
                  <ArrowRight size={16} className="group-hover/btn:translate-x-1 transition-transform" data-id="element-252" />
                </a>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}